/* eslint-disable no-underscore-dangle */
/* eslint-disable react/jsx-no-useless-fragment */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import {
  Box,
  CircularProgress,
  Typography,
  Accordion as MuiAccordion,
  AccordionSummary,
  AccordionDetails
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import ShowChartIcon from '@mui/icons-material/ShowChart';
import { fetchElementoById, fetchElementoByIdGrafica, limpiarElemento } from '../../../actions/elemento';
import AccordionObjetivos from '../../../components/acordion-objetivos';
import Bread from '../../../components/breadcrumb';
import Tab from '../../../components/tab';
import { routeElementoInfo } from '../../../utils/routesBread';
import AccordionElemento from '../accordion-elemento';
import InfoCard from '../../../components/info-card';

const InfoElemento = () => {
  const { elemento, isLoading } = useSelector((state) => state.elementoReducer);
  const [elementoData, setElementoData] = useState(null);
  const { id } = useParams();
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(fetchElementoById(id));
    return () => {
      dispatch(limpiarElemento());
    };
  }, [dispatch, id]);

  useEffect(() => {
    setElementoData(elemento);
  }, [elemento]);

  useEffect(() => {
    const intervalId = setInterval(() => dispatch(fetchElementoByIdGrafica(id)), 30000);
    return () => {
      clearInterval(intervalId);
    };
  }, [dispatch, id]);

  return (
    <div>
      <div className="header-nav">
        <Bread routes={routeElementoInfo} />
      </div>
      <div className="info-container">
        {isLoading ? (
          <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
            <CircularProgress />
          </Box>
        ) : (
          <>
            {!elementoData ? (
              <p className="info-container__nothing">
                Los detalles del elemento no se encontraron
              </p>
            ) : (
              <>
                {/* Información básica del elemento */}
                <InfoCard
                  title="Información del Elemento"
                  icon={<AccountTreeIcon />}
                  content={
                    <Box>
                      <Typography variant="h6" gutterBottom>
                        {elementoData.nombre}
                      </Typography>
                      {elementoData.descripcion && (
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Descripción:</strong> {elementoData.descripcion}
                        </Typography>
                      )}
                      {elementoData.codigo && (
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Código:</strong> {elementoData.codigo}
                        </Typography>
                      )}
                      {elementoData.empresa && (
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Empresa:</strong> {elementoData.empresa.nombre}
                        </Typography>
                      )}
                      {elementoData.proyecto && (
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Proyecto:</strong> {elementoData.proyecto.nombre}
                        </Typography>
                      )}
                      {elementoData.area && (
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Área:</strong> {elementoData.area}
                        </Typography>
                      )}
                      {elementoData.linea && (
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Línea:</strong> {elementoData.linea}
                        </Typography>
                      )}
                      {elementoData.proceso && (
                        <Typography variant="body2" sx={{ mb: 1 }}>
                          <strong>Proceso:</strong> {elementoData.proceso}
                        </Typography>
                      )}
                      {elementoData.tipo && (
                        <Typography variant="body2">
                          <strong>Tipo:</strong> {elementoData.tipo}
                        </Typography>
                      )}
                    </Box>
                  }
                />

                {/* Objetivos */}
                <AccordionObjetivos />
                
                {/* Acordeón de estadísticas */}
                {elementoData.estadisticas && (
                  <MuiAccordion defaultExpanded sx={{ mb: 2 }}>
                    <AccordionSummary
                      expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                      sx={{ 
                        backgroundColor: '#1F2A38', 
                        color: 'white',
                        '&:hover': {
                          backgroundColor: '#303C54',
                        },
                        '& .MuiTypography-root': {
                          color: 'white',
                        },
                        '& .MuiSvgIcon-root': {
                          color: 'white',
                        }
                      }}
                    >
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                        <ShowChartIcon />
                        <Typography variant="h6">
                          Estadísticas del Elemento
                        </Typography>
                      </Box>
                    </AccordionSummary>
                    <AccordionDetails sx={{ p: 2 }}>
                      <Box sx={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 2 }}>
                        {Object.entries(elementoData.estadisticas).map(([key, value]) => (
                          <Box key={key} sx={{ textAlign: 'center', p: 2, border: '1px solid #e0e0e0', borderRadius: 1 }}>
                            <Typography variant="h5" color="primary">
                              {value}
                            </Typography>
                            <Typography variant="caption" color="textSecondary">
                              {key.charAt(0).toUpperCase() + key.slice(1)}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </AccordionDetails>
                  </MuiAccordion>
                )}
                
                {/* Acordeón de tarjetas */}
                <AccordionElemento data={elementoData} />
                
                {/* Acordeón de gráficas */}
                <MuiAccordion defaultExpanded sx={{ mb: 2 }}>
                  <AccordionSummary
                    expandIcon={<ExpandMoreIcon sx={{ color: 'white' }} />}
                    sx={{ 
                      backgroundColor: '#1F2A38', 
                      color: 'white',
                      '&:hover': {
                        backgroundColor: '#303C54',
                      },
                      '& .MuiTypography-root': {
                        color: 'white',
                      },
                      '& .MuiSvgIcon-root': {
                        color: 'white',
                      }
                    }}
                  >
                    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                      <ShowChartIcon />
                      <Typography variant="h6">
                        Gráficas
                      </Typography>
                    </Box>
                  </AccordionSummary>
                  <AccordionDetails sx={{ p: 0 }}>
                    {(elementoData?.graficas || elementoData?.graficasSankey) ? (
                      <Tab
                        dataGrafica={elementoData?.graficas || []}
                        dataSankey={elementoData?.graficasSankey || []}
                      />
                    ) : (
                      <Box sx={{ p: 2, textAlign: 'center', color: 'text.secondary' }}>
                        No hay gráficas configuradas para este elemento
                      </Box>
                    )}
                  </AccordionDetails>
                </MuiAccordion>
              </>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InfoElemento;